import {BaseModel, BaseNomenclatorModel} from './base.model';

export class UnitMeasureModel extends BaseNomenclatorModel{
    uid: string;
    name: string;
}
